import NavigationDashboardTab from '../navigationDashboardTab';
import { PageSmallLoader } from '../../../component/PageLoader';
import { useEffect, useState } from 'react';
import { fetchDashboardCardData } from '../../../services/dashboard';
import verifyIcon from '../../../assets/image/verify.svg';
import bucketIcon from '../../../assets/image/bucket_icon.svg';
import { getDate } from '../../../utils/dateUtils';
import { useNavigate } from 'react-router-dom';
import { addDays } from 'date-fns';

const RecentTransactions = ({ card, isCustomizing, handleRemoveCard, filter }) => {
	const [activeTab, setActiveTab] = useState('All');
	const { title, layout_card_id } = card;
	const [reports, setReports] = useState([]);
	const [data, setData] = useState(null);
	const [isLoading, setLoading] = useState(false);
	const suburl = localStorage.getItem('suburl');
	const navigate = useNavigate();
	const handleFetchCardData = async () => {
		try {
			setLoading(true);
			const { recent_transactions } = await fetchDashboardCardData(layout_card_id, {
				page_size: 6,
				filter_by: filter.filter_by,
				start_date:
					filter.start_date !== null ? addDays(new Date(filter.start_date), 1).toISOString() : '',
				end_date:
					filter.end_date !== null ? addDays(new Date(filter.end_date), 1).toISOString() : '',
			});
			setData(recent_transactions);
			const list = recent_transactions.all.map((item) => {
				return {
					name: item.vendor !== undefined ? item.vendor?.vendor_name : item.customer?.name,
					type:
						item.payment_mode !== undefined && item.payment_mode?.payment_method_name !== undefined
							? item.payment_mode?.payment_method_name
							: item.payment_mode,
					number:
						item.payment_number !== undefined ? item.payment_number : item.payment_receive_number,
					amount: item.payment_amount !== undefined ? item.payment_amount : item.cash_handed,
					date: item.date,
				};
			});
			setReports(list);
		} catch (error) {
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (filter.filter_by === 'custom_date' && !filter.start_date && !filter.end_date) return;
		handleFetchCardData();
	}, [filter]);

	const getReports = () => {
		if (activeTab === 'All' && data !== null) {
			const list = data.all?.map((item) => {
				return {
					name: item.vendor !== undefined ? item.vendor?.vendor_name : item.customer?.name,
					type:
						item.payment_mode !== undefined && item.payment_mode?.payment_method_name !== undefined
							? item.payment_mode?.payment_method_name
							: item.payment_mode,
					number:
						item.payment_number !== undefined ? item.payment_number : item.payment_receive_number,
					amount: item.payment_amount !== undefined ? item.payment_amount : item.cash_handed,
					date: item.date,
				};
			});
			setReports(list);
		} else if (activeTab === 'Revenue') {
			const list = data.payment_receives.map((item) => {
				return {
					name: item.customer?.name,
					type: item.payment_mode?.payment_method_name,
					number: item.payment_receive_number,
					amount: item.cash_handed,
					date: item.date,
				};
			});
			setReports(list);
		} else if (activeTab === 'Expenses') {
			const list = data.payment_mades.map((item) => {
				return {
					name: item.vendor?.vendor_name,
					type: item.payment_mode,
					number: item.payment_number,
					amount: item.payment_amount,
					date: item.date,
				};
			});
			setReports(list);
		}
	};

	useEffect(() => {
		if (activeTab && data) {
			getReports();
		}
	}, [activeTab, data]);

	return (
		<div className="flex flex-col bg-white rounded-top-4">
			<div className="px-4 py-3 d-flex justify-content-between grids-header-bg-color rounded-top-4">
				<h3 className="fs-4 font-semibold  text-dark">{title}</h3>
				<div className="d-flex flex-row item-center gap-4">
					{activeTab !== 'All' && reports.length > 0 && (
						<div
							className="text-bold fs-5 cursor-pointer text-primary"
							style={{}}
							onClick={() => {
								if (!isCustomizing) {
									if (activeTab === 'Revenue') {
										navigate(`/user/${suburl}/payments-received`);
									} else {
										navigate(`/user/${suburl}/payment-made`);
									}
								}
							}}
						>
							View All
						</div>
					)}
				</div>
			</div>
			{isLoading ? (
				<div
					className="d-flex justify-content-center align-items-center"
					style={{ minHeight: '300px' }}
				>
					<PageSmallLoader />
				</div>
			) : (
				<div className="flex-1 overflow-auto">
					{isCustomizing && (
						<div
							style={{
								position: 'absolute',
								top: -10,
								right: -10,
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								width: '20px',
								height: '20px',
								backgroundColor: 'red',
								borderRadius: '50%',
								cursor: 'pointer',
								zIndex: 100,
							}}
							onClick={(e) => {
								handleRemoveCard(layout_card_id, e);
							}}
						>
							<div
								style={{
									color: '#000',
									fontSize: '16px',
									fontWeight: '600',
									lineHeight: '1',
									paddingBottom: '5px',
								}}
								onClick={() => handleRemoveCard(layout_card_id)}
							>
								−
							</div>
						</div>
					)}
					<div className="px-4 mb-2">
						<div>
							<ul className="nav">
								{['All', 'Revenue', 'Expenses'].map((item, index) => (
									<li
										key={index}
										className="nav-item"
									>
										<a
											className={`nav-link ${activeTab === item ? 'active' : ''} cursur-pointer fs-4 font-semibold`}
											style={{ cursor: 'pointer' }}
											onClick={() => {
												if (!isCustomizing) {
													setActiveTab(item);
												}
											}}
										>
											{item}
										</a>
									</li>
								))}
							</ul>
						</div>
						{/* <NavigationDashboardTab
							activeTab={activeTab}
							setActiveTab={setActiveTab}
							navTabs={['All', 'Revenue', 'Expenses']}
						/> */}
					</div>
					<table>
						<tbody className="bg-white">
							{reports?.length === 0 ? (
								<tr>
									<td
										colSpan="4"
										className="table-bg-color border-0"
										style={{ height: '200px' }}
									>
										<div className="d-flex justify-content-center align-items-center w-100 h-100 ">
											<span className="fs-5 lead">No data found!</span>
										</div>
									</td>
								</tr>
							) : (
								reports?.map((row, index) => (
									<tr
										key={index}
										className="hover:bg-gray-50"
									>
										<td className="py-2 table-bg-color text-center border-0">
											{
												<img
													src={row.number.includes('PR') ? verifyIcon : bucketIcon}
													alt="verify"
													width={30}
													height={30}
												/>
											}
										</td>
										<td className="py-2 table-bg-color text-start border-0">
											<div className="fs-5 text-dark">{row.name}</div>
											<div className="fs-6 text-secondary">{`${row.number} | ${row.type}`}</div>
										</td>
										<td className="py-2 table-bg-color text-end border-0">
											<div className="fs-5 text-dark">{`₹ ${row.amount}`}</div>
											<div className="fs-6 text-secondary">{getDate(row.date)}</div>
										</td>
									</tr>
								))
							)}
						</tbody>
					</table>
				</div>
			)}
		</div>
	);
};
export default RecentTransactions;
